import React from "react";
import UsuariosRegistradosList from "../../components/MovilidadElectrica/UsuariosRegistradosList";
import { MovilidadElectricaProvider } from "../../context/MovilidadElectricaContext";

const UsuariosRegistrados = () => {
  return (
    <MovilidadElectricaProvider>
      <UsuariosRegistradosList />
    </MovilidadElectricaProvider>
  );
};

export default UsuariosRegistrados;
